"use client";
import { AppShell } from "@/app/_providers/AppShell";
import { AxiosSetup } from "@/app/_providers/AxiosSetup";
import IntercomProvider from "@/intercom/IntercomProvider";
import { MantineProvider } from "@mantine/core";

export function AppProviders({ children }) {
  return (
    <MantineProvider>
      <AxiosSetup />
      <AppShell>{children}</AppShell>
      <IntercomProvider />
    </MantineProvider>
  );
}